module.exports = __webpack_public_path__ + "img/37.31b52f19.png";